import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { TableList } from 'seagull';
import { makeEditableTableItem } from '../EditDraftsTable.utils';
import AdvancedSettingsCell from '../serviceCells/AdvancedSettingsCell';
import DeleteServiceAction from '../serviceCells/DeleteServiceAction';
import { ServiceBillingCell } from '../serviceCells/ServiceBillingCell';
import ServiceDescriptionCell from '../serviceCells/ServiceDescriptionCell';
import ServiceNameCell from '../serviceCells/ServiceNameCell';
import ServiceRateCell from '../serviceCells/ServiceRateCell';
export default function EditDraftServiceRow(props) {
    return /*#__PURE__*/ _jsx(TableList.Row, {
        size: "fluid",
        items: [
            makeEditableTableItem(/*#__PURE__*/ _jsx(ServiceNameCell, _object_spread({}, props))),
            makeEditableTableItem(/*#__PURE__*/ _jsx(ServiceBillingCell, _object_spread({}, props))),
            makeEditableTableItem(/*#__PURE__*/ _jsx(ServiceRateCell, _object_spread({}, props))),
            makeEditableTableItem(/*#__PURE__*/ _jsx(ServiceDescriptionCell, _object_spread({}, props))),
            makeEditableTableItem(/*#__PURE__*/ _jsx(AdvancedSettingsCell, _object_spread({}, props)))
        ],
        actionColumn: /*#__PURE__*/ _jsx(DeleteServiceAction, _object_spread({}, props))
    });
}
